<div>
  <form novalidate [formGroup]="profileForm" (ngSubmit)="save()">
    <div class="col col-md-8 col-sm-4">
      <div class="input-group mb-2">
        <label class="control-label col-sm-6">Full name</label>
        <input
          type="text"
          formControlName="fullName"
          class="form-control col-sm-4"
          maxlength="10"
          [readonly]="true"
        />
      </div>
      <div class="input-group mb-2">
        <label class="control-label col-sm-6">Email address</label>
        <input
          type="text"
          formControlName="email"
          class="form-control col-sm-4"
          maxlength="50"
          [readonly]="true"
        />
      </div>
      <div class="input-group mb-2">
        <label class="control-label col-sm-6">Phone</label>
        <input
          type="text"
          formControlName="phone"
          class="form-control col-sm-4"
          maxlength="50"
        />
      </div>
      <div class="input-group mb-2">
        <label class="control-label col-sm-6">Mobile</label>
        <input
          type="text"
          formControlName="mobile"
          class="form-control col-sm-4"
          maxlength="50"
        />
      </div>
      <div class="input-group mb-2">
        <label class="control-label col-sm-6">&nbsp;</label>
        <button type="submit" class="btn btn-primary" >Save</button>
      </div>
    </div>
  </form>
  
</div>
